import React, { useState, useEffect } from "react";
import { Container, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { getBookings } from "../../store/slices/booking";
import { useDispatch, useSelector } from "react-redux";

export default function Bookings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    loading,
    error,
    bookingList = [],
  } = useSelector((state) => state.booking);

  const pagelimit = 25;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getBookings());
  }, [dispatch]);

  useEffect(() => {
    if (currentPage > Math.ceil(bookingList.length / pagelimit)) {
      setCurrentPage(1);
    }
  }, [bookingList]);

  const totalPages = Math.ceil(bookingList.length / pagelimit);
  const startIndex = (currentPage - 1) * pagelimit;

  const paginatedBookings = bookingList?.slice(
    startIndex,
    startIndex + pagelimit,
  );

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN");
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/booking")}
          >
            Bookings
          </span>
        </div>
      </div>

      <Container>
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Booking Id</th>
                    <th className="text-center">Guest Name</th>
                    <th className="text-center">Travel Date</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center">
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : error ? (
                    <tr>
                      <td colSpan="6" className="text-center text-danger py-4">
                        {error}
                      </td>
                    </tr>
                  ) : paginatedBookings.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    paginatedBookings.map((booking, index) => (
                      <tr key={booking._id}>
                        <td className="text-center">
                          {startIndex + index + 1}
                        </td>

                        <td className="text-center" style={{ width: "150px" }}>
                          {booking.bookingNumber || "-"}
                        </td>

                        <td className="text-center">
                          {booking.lead?.name || "-"}
                        </td>

                        <td className="text-center">
                          {formatDate(booking.travelDate)}
                        </td>

                        <td className="text-center">
                          <span className="guest-status booked">
                            {booking.bookingStatus || "-"}
                          </span>
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center">
                            <button
                              className="action-btn edit-btn"
                              title="View"
                              onClick={() =>
                                navigate(`/admin/booking-details/${booking._id}`)
                              }
                            >
                              <FaEye size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button
                  size="sm"
                  variant="light"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Prev
                </Button>

                {[...Array(totalPages)].map((_, i) => (
                  <Button
                    key={i}
                    size="sm"
                    variant={currentPage === i + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </Button>
                ))}

                <Button
                  size="sm"
                  variant="light"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </Button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
